import { UPDATE_EDITCARD, UPDATE_MENU_RESPONSIVO } from './actions_types';

export const updateCard = value => ({
    type: UPDATE_EDITCARD,
    editCard: value
});

export const toogleMenu = value => ({
    type: UPDATE_MENU_RESPONSIVO,
    showMenu: value
});